import React, { useState } from 'react';
import { usePrdStore } from '../store/prd-store';
import { format } from 'date-fns';

export const VersionHistory: React.FC = () => {
  const { versionHistory, restoreVersion } = usePrdStore();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isExpanded) {
    return (
      <button
        onClick={() => setIsExpanded(true)}
        className="p-2 border-l text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        title="Show version history"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </button>
    );
  }

  return (
    <div className="prd-version-history w-80 border-l bg-white dark:bg-gray-800 flex flex-col">
      {/* Header */}
      <div className="p-4 border-b flex items-center justify-between">
        <h3 className="font-medium text-gray-900 dark:text-gray-100">
          Version History
        </h3>
        <button
          onClick={() => setIsExpanded(false)}
          className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Version List */}
      <div className="flex-1 overflow-y-auto">
        {versionHistory.length > 0 ? (
          <div className="p-4 space-y-3">
            {versionHistory
              .sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime())
              .map(version => (
                <div
                  key={version.id}
                  className="border rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <div className="font-medium text-sm text-gray-900 dark:text-gray-100">
                        v{version.version}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400">
                        {format(version.timestamp, 'MMM d, yyyy HH:mm')}
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        if (confirm('Restore this version? Current changes will be lost.')) {
                          restoreVersion(version.id);
                        }
                      }}
                      className="text-xs text-blue-500 hover:text-blue-600"
                    >
                      Restore
                    </button>
                  </div>
                  
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                    {version.changes}
                  </p>
                  
                  <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                    <img
                      src={version.author.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(version.author.name)}`}
                      alt={version.author.name}
                      className="w-4 h-4 rounded-full"
                    />
                    <span>{version.author.name}</span>
                  </div>
                </div>
              ))}
          </div>
        ) : (
          <div className="p-4 text-center">
            <svg className="w-12 h-12 mx-auto text-gray-300 dark:text-gray-600 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              No version history yet
            </p>
          </div>
        )}
      </div>
    </div>
  );
};